import React from "react";
import "./Experience_The_Game_Like_Never_Before.css";
import Common_Heading from "../../common-components/common-heading/Common_Heading";

const ExperienceTheGameLikeNeverBefore = () => {
  return (
    <section className="experience-section">
      <div className="container">
        <div className="experience-card">
          <div className="card-wrapper">
            <div className="row align-items-center">
              <div className="col-lg-7 col-md-12">
                <div className="text_holder">
                  <div className="dream-heading">
                    <Common_Heading
                      head1={
                        <>
                          READY TO MAKE <br></br> YOUR DREAM TEAM ?
                        </>
                      }
                    />
                  </div>
                  <p className="experience-text">
                    Join the millions of cricket fans & start your fantasy
                    journey today!
                  </p>

                  <p className="experience-subtext">
                    <strong>Experience the game like never before!</strong>
                  </p>

                  <div className="store-btn">
                    <a
                      href="https://play.google.com/store/games?device=windows"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="playstore-btn"
                    >
                      <img
                        src="/assets/images/Ready_To_Make_Dream_Team/google-play-btn.png"
                        alt="Get it on Google Play"
                        className="btn"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-12 text-center">
                <div className="mobile-mockups">
                  <img
                    src="/assets/images/Ready_To_Make_Dream_Team/experience-the-game-like-never-before.png"
                    alt="Fantasy App Screen 1"
                    className="phone phone-1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceTheGameLikeNeverBefore;
